import { useState } from 'react';
import PropTypes from 'prop-types';

import { api } from 'api';
import { isObjectEmpty, notify } from 'libs/common';
import { themes, Button } from '../buttons';
import { Items } from './items';
import { Content, Inner, Clear, Selected, ForAll } from './set-actions.styled';

export const SetActions = (props) => {
  const { selected, actions, clear, refresh, getFilter, cntAll, clientId } = props;
  const [action, setAction] = useState(null);
  const [bulk, setBulk] = useState(false);
  const [working, setWorking] = useState(false);

  if (isObjectEmpty(selected) || !actions || !actions.length) {
    return null;
  }

  const cnt = Object.keys(selected).length;

  /**
   * update items
   * @param {*} data
   */
  const updateItems = (data) => {
    const out = {};
    if (bulk) {
      out.filters = getFilter ? getFilter() : {};
      out[action.idsParam] = [];
      if (clientId) {
        out.filters.client_id = clientId;
      }
    } else {
      out[action.idsParam] = Object.keys(selected);
      out.filters = {};
    }
    const otherParams = action.otherParams ?? {};
    if (data) {
      Object.keys(data).forEach((fn) => {
        const fnOk = otherParams[fn] ?? fn;
        out[fnOk] = data[fn];
      });
    }
    const test = false;
    let method = action.method;
    if (test) {
      console.log('🚀 ~ bulk:', method, out, out.filters);
      method += 'Test';
    }

    setWorking(true);
    api
      .call(method, out)
      .then((data) => {
        const ok = data?.success?.length;
        const fail = data?.failure?.length;
        let title = '';
        let type = 'success';
        if (ok) {
          title += 'Успешно выполнено'; //: ' + ok.toString();
        }
        if (fail) {
          type = 'danger';
          // if (title) {
          //   title += ', ';
          // }
          title = 'Пропущено: ' + fail.toString();
        }
        notify('Групповое изменение', title, type);
        refresh();
        setAction(null);
        setBulk(false);
      })
      .catch((error) => {
        notify('Групповое изменение', error.toString());
      })
      .finally(() => {
        setWorking(false);
      });
  };

  /**
   * change bulk
   */
  const changeBulk = () => {
    setBulk((bulk) => !bulk);
  };

  const Cmp = action ? action.form : null;

  return (
    <>
      <Content>
        <Inner>
          <Clear>
            <Button theme={themes.gray} title="Очистить выделение" onClick={clear}>
              <img src="/images/cross_icon_white.png" alt="" />
            </Button>
          </Clear>
          <Selected>
            Выбрано: <b>{bulk ? cntAll : cnt}</b>
          </Selected>
          <Items actions={actions} setAction={setAction} />
          <ForAll>
            <label>
              <input type="checkbox" checked={bulk} onChange={changeBulk} /> <span>для всех</span>
            </label>
          </ForAll>
        </Inner>
      </Content>
      {action && (
        <Cmp
          close={() => setAction(null)}
          action={updateItems}
          dict={action.dict}
          dictExclude={action.dictExclude}
          dict_force_name={action.dict_force_name}
          working={working}
          title={action.title}
        />
      )}
    </>
  );
};

SetActions.propTypes = {
  refresh: PropTypes.func,
  clear: PropTypes.func.isRequired,
  selected: PropTypes.object,
  getFilter: PropTypes.func,
  actions: PropTypes.array,
  cntAll: PropTypes.number,
  clientId: PropTypes.any,
};
